import homeDemoData from "./homeDemo.json";
import type { SupportedLanguage } from "../locales";

export type HomeDemoContent = {
  title: string;
  description: string;
  beforeLabel: string;
  beforeDescription: string;
  afterLabel: string;
  afterDescription: string;
};

const homeDemoContentByLanguage = homeDemoData as Record<
  SupportedLanguage,
  HomeDemoContent
>;

export function getHomeDemoContent(language: SupportedLanguage): HomeDemoContent {
  return homeDemoContentByLanguage[language] || homeDemoContentByLanguage.en;
}
